const allCategories = [
    { codCategoria: 3,descricao: "BISCOITOS E BOMBONIERE" },
    { codCategoria: 4,descricao: "HIGIENE PESSOAL" },
    { codCategoria: 5,descricao: "CONDIMENTOS E ESPECIARIAS" },
    { codCategoria: 6,descricao: "HIGIENE E LIMPEZA" },
    { codCategoria: 7,descricao: "ENLATADOS E CONSERVAS" },
    { codCategoria: 8,descricao: "UTILIDADES DOMESTICAS" },
    { codCategoria: 12,descricao: "BEBIDAS" },
    { codCategoria: 15,descricao: "PRODUTOS ALIMENTICIOS DIVERSOS" },
    { codCategoria: 17,descricao: "OLEOS E AZEITES" },
    { codCategoria: 30,descricao: "FARINACEOS E SEUS DERIVADOS" },
    { codCategoria: 25,descricao: "DESCARTAVEIS" },
    { codCategoria: 10,descricao: "SEMENTES E GRAOS" },
    { codCategoria: 13,descricao: "DOCES E SOBREMESAS" },
    { codCategoria: 24,descricao: "EMBALAGENS" },
    { codCategoria: 29,descricao: "E.P.I."  },
    { codCategoria: 18,descricao: "LEITE E DERIVADOS DO LEITE" },
    { codCategoria: 22,descricao: "HORTIFRUTY GRANJEIROS" },
]

export default allCategories